import Axios from "axios";
import { StorageAuth } from "../localStorage";
import {
  AxiosAuthInjector,
  AxiosRedirectUnauthorize,
  ConnectivityCheck,
} from "./interceptors";

const AxiosAuth = Axios.create();

AxiosAuthInjector.Add(AxiosAuth);
ConnectivityCheck.Add(AxiosAuth);
AxiosRedirectUnauthorize.Add(AxiosAuth, "/", () => {
  StorageAuth.AccessToken = undefined;
});

export { AxiosAuth };
